import { useMemo } from "react";
import { ServiceCard } from "@/components/site/ServiceCard";
import { BUDGET_CAP } from "@/lib/constants";

export const PackageBuilder = ({
  services,
  selectedIds,
  onToggle,
  total,
  loading,
}) => {
  const remaining = BUDGET_CAP - total;

  const cards = useMemo(() => {
    return services.map((s) => {
      const selected = selectedIds.includes(s.id);
      // Disabled if not selected AND adding it would exceed the cap
      const disabled = !selected && s.price > remaining;
      return (
        <ServiceCard
          key={s.id}
          service={s}
          selected={selected}
          disabled={disabled}
          onToggle={onToggle}
        />
      );
    });
  }, [services, selectedIds, remaining, onToggle]);

  return (
    <section
      id="builder"
      data-testid="package-builder-section"
      className="border-b-2 border-black bg-white"
    >
      <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-24">
        <div className="mb-10 grid grid-cols-1 gap-6 md:mb-14 md:grid-cols-12">
          <div className="md:col-span-7">
            <div className="mb-4 inline-block border-2 border-black bg-[#9D4CDD] px-2 py-1 font-display text-[10px] font-bold uppercase tracking-[0.25em] text-white">
              The Builder
            </div>
            <h2
              data-testid="builder-headline"
              className="font-display text-4xl font-black leading-[0.95] tracking-tighter text-black sm:text-5xl md:text-6xl"
            >
              Build your
              <br />
              <span className="text-[#9D4CDD]">garden package.</span>
            </h2>
          </div>
          <div className="md:col-span-5 md:pt-3">
            <p className="font-display text-base leading-relaxed text-black/70 md:text-lg">
              Tap any service to add it to your list. Items that would push you
              over the <strong className="text-black">£2,000</strong> cap will
              lock automatically — no nasty surprises.
            </p>
          </div>
        </div>

        {loading ? (
          <div
            data-testid="builder-loading"
            className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3"
          >
            {Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="h-[360px] border-2 border-black bg-[#F4F4F5] animate-pulse"
              />
            ))}
          </div>
        ) : (
          <div
            data-testid="builder-grid"
            className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3"
          >
            {cards}
          </div>
        )}
      </div>
    </section>
  );
};
